module.exports = __webpack_public_path__ + "img/passport_two.6b98e883.png";